import React, { useState,useEffect } from "react";
import { Image } from "antd";
import "./styles/evaluationsFinish.css";
import highfive from "./img/highfive.png";
import server, { endpoints } from '../../../utils/server';
import { message } from "antd";
const EvaluationsF = ({onReset,team,selectedT,selectedE,idCycle}) => {

  const evaluationName = selectedE.name;



  const registerEvaluationAnswers = async () =>{  
    try {

    if (!selectedT || !selectedE) {

      return;
      
    }

    const params = {
      id_evaluation: selectedE.id,
      id_team: selectedT.id_team,
      id_cycle: idCycle,
    }
  
    const body = {
      questions: selectedE.questions,
    }
    const res = await server(endpoints.registerEvaluationAnswers.route, endpoints.registerEvaluationAnswers.method, params, body);
    const {error_message } = res;
    if (error_message){
      message.error(error_message);
      return;
    }
    else{ 
      message.success("Respuesta registrada");
      
     onReset();
     window.location.reload();
    }
  }
  catch (error) {
    message.error(error);
  }
  }

    
  return (
    <div className="evaluationFinish-titles">
      <h2>Evaluación: {evaluationName}</h2>
      <h1>Respuesta Enviada</h1>
      <h3>¡Muchas gracias por responder la evaluación!</h3>
      <div className="evaluationFinish-imageContainer">
        <Image width={400} src={highfive} preview={false} />
      </div>
      
      <div className="evaluationsFinish-readyButtonContainer">
        <button className="evaluationsFinish-readyButton" onClick={()=>{registerEvaluationAnswers();}}>¡Listo!</button>
      </div>

    </div>
  );
};
export default EvaluationsF;
